import React from "react";
import { Link } from 'react-router-dom';

import styles from './Footer.module.scss';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        {/* Colonne 1 : Apps en demo */}
        <div className={styles.footerColumn}>
          <ul className={styles.footerLegal}><span className={styles.textBold}>Apps en demo</span>
            <li><Link to="/seo-generator">Générateur de contenu SEO</Link></li>
          </ul>
        </div>

        {/* Colonne 2 : Sections */}
        <div className={styles.footerColumn}>
          <ul className={styles.footerMenu}><span className={styles.textBold}>Plan du site</span>
            <li><Link to="/">Accueil</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* Colonne 3 : Infos */}
        <div className={styles.footerColumn}>
          <ul className={styles.footerLegal}><span className={styles.textBold}>Informations</span>
            <li><Link to="/mentions-legales">Mentions légales</Link></li>
            <li><a href="#cgv">CGV</a></li>
            <li><Link to="/politique-confidentialite">Politique de confidentialité</Link></li>
          </ul>
        </div>

        {/* Colonne 4 : Logo et réseaux sociaux */}
        <div className={styles.footerColumn}>
          <div className={styles.footerLogo}>
            <img src="test4.png" alt="Logo" className={styles.logo} />
          </div>
          <div className={styles.footerSocial}>
            {/* <a href="https://facebook.com/100087577732958/" target="_blank" rel="noopener noreferrer" aria-label="Facebook"> */}
            <a href="https://facebook.com/61556543451327/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <i className="fab fa-facebook"></i>
            </a>
            {/* <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <i className="fab fa-twitter"></i>
            </a> */}
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>
      </div>
      <div className={styles.footerBottom}>
        <p>&copy; {new Date().getFullYear()} Scriptales. Tous droits réservés.</p>
      </div>
    </footer>
  );
};

export default Footer;
